<template>
    <div
        :class="{'is-success': isSuccess, 'is-active': isActive}"
        :style="style"
        class="app-step">
        <!-- icon & line -->
        <div class="app-step__head">
            <div
                :style="isLast ? { display: 'none' } : '' "
                class="app-step__line"/>

            <div class="app-step__icon">
                <span v-if="isSuccess" class="app-step__icon-inner is-status" />
                <div v-else class="app-step__icon-inner">{{ index+1 }}</div>
            </div>
            <!-- <div class="el-step__icon" :class="`is-${icon ? 'icon' : 'text'}`">
                <slot
                    v-if="currentStatus !== 'success' && currentStatus !== 'error'"
                    name="icon">
                    <i v-if="icon" class="el-step__icon-inner" :class="[icon]"></i>
                    <div class="el-step__icon-inner" v-if="!icon && !isSimple">{{ index + 1 }}</div>
                </slot>
                <i
                v-else
                :class="['el-icon-' + (currentStatus === 'success' ? 'check' : 'close')]"
                class="el-step__icon-inner is-status"></i>
            </div> -->
        </div>
        <div class="app-step__title">
            {{ title }}
        </div>
    </div>
</template>

<script>
export default {
    name: 'app-step',
    props: {
        title: String
    },
    data() {
        return {
            index: -1
        }
    },
    computed: {
        active() {
            return this.$parent.active
        },
        stepsCount() {
            return this.$parent.steps.length;
        },
        style() {
            const style = {};
            style.maxWidth = 100 / this.stepsCount + '%'
            return style
        },
        isActive() {
            return this.active === this.index
        },
        isSuccess() {
            return this.active > this.index
        },
        isFirst() {
            return this.index === 0
        },
        isLast() {
            return this.stepsCount-1 === this.index
        }
    },
    beforeCreate() {
        this.$parent.steps.push(this);
    },
    beforeDestroy() {
        const steps = this.$parent.steps;
        const index = steps.indexOf(this);
        if (index >= 0) {
            steps.splice(index, 1);
        }
    },
    methods: {
        
    }
}
</script>

<style lang="stylus">
    .app-step
        width: 100%
        text-align: center
        border-color: #C0C4CC
        color: #C0C4CC
        &.is-success
            border-color: #67C23A
            color: #67C23A
        &.is-active
            border-color: #303133
            color: #303133
            .app-step__title
                font-weight: 700
    
        .app-step__head
            position: relative
            width: 100%

            .app-step__line
                left: 50%
                right: -50%
                height: 2px
                top: 11px
                position: absolute
                border-color: inherit
                background-color: #C0C4CC

            .app-step__icon        
                position: relative
                z-index: 1
                display: inline-flex
                -webkit-box-pack: center
                -ms-flex-pack: center
                justify-content: center
                -webkit-box-align: center
                -ms-flex-align: center
                align-items: center
                width: 24px
                height: 24px
                font-size: 14px
                box-sizing: border-box
                background: #FFF
                transition: .15s ease-out
                border-radius: 50%
                border: 2px solid
                border-color: inherit
                .app-step__icon-inner
                    display: inline-block
                    user-select: none
                    text-align: center
                    font-weight: 700
                    line-height: 1
                    color: inherit
                    &.is-status::after
                        content: ''
                        position: absolute
                        left: 7px
                        top: 4px
                        font-size: 12px
                        display: inline-block
                        transform: rotate(45deg)
                        height: 8px
                        width: 4px
                        border-bottom: 2px solid #67C23A
                        border-right: 2px solid #67C23A

        .app-step__title
            font-size: 16px
            line-height: 38px
            font-weight: 400
</style>